import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import './index.css';
import App from './App';
import { FiltersProvider } from './app/FiltersContext';
const root=ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ThemeProvider attribute="class" defaultTheme="system" enableSystem><FiltersProvider><App/></FiltersProvider></ThemeProvider></React.StrictMode>);
